<div class="container-fluid dashboard-wrapper mt-1">

  <!-- ================= HEADER CARD ================= -->
  <div class="dashboard-header-card">
    <div class="dashboard-title-wrap">
      <i class="fas fa-file-lines"></i>
      <span>Generate Report</span>
    </div>

    <div class="dashboard-actions">
      <button class="btn dash-btn refresh" (click)="resetForm()">
        <i class="fas fa-eraser"></i>
        Reset
      </button>
    </div>
  </div>

  <!-- ================= GENERATE REPORT CARD ================= -->
  <div class="batch-card horizontal-card">

    <div class="row align-items-end">

      <!-- Dropdown 1 -->
      <div class="col-lg-4 col-md-5 col-sm-12 mb-2">
        <label class="form-label fw-semibold">Select Batch</label>
        <select class="form-select" [(ngModel)]="selectedBatch" (change)="onBatchChange()">
          <option value="" disabled>-- Choose Batch --</option>
          <option *ngFor="let b of batches" [value]="b.SDBatchId">
            {{ b.BatchName }}
          </option>
        </select>
      </div>

      <!-- Dropdown 2 -->
      <div class="col-lg-4 col-md-5 col-sm-12 mb-2">
        <label class="form-label fw-semibold">Select Round</label>
        <select class="form-select" [(ngModel)]="selectedRound">
          <option value="" disabled>-- Choose Round --</option>
          <option *ngFor="let r of roundList" [value]="r">
            {{ r }}
          </option>
        </select>
      </div>

      <!-- Generate Button -->
      <div class="col-lg-4 col-md-2 col-sm-12 mb-2">
        <button class="btn dash-btn primary w-100" [disabled]="!selectedBatch || !selectedRound"
          (click)="generateReport()">
          <i class="fas fa-file-circle-check"></i>
          Generate
        </button>
      </div>

    </div>

  </div>


  <!-- ================= DOWNLOAD REPORT CARD ================= -->
  <div class="dashboard-header-card mt-3">
    <div class="dashboard-title-wrap">
      <i class="fas fa-download"></i>
      <span>Download Report</span>
    </div>
  </div>

  <div class="batch-card horizontal-card">

    <div class="row align-items-end">

      <!-- Download Dropdown -->
      <div class="col-lg-8 col-md-7 col-sm-12 mb-2">
        <label class="form-label fw-semibold">Select Report</label>
        <select class="form-select" [(ngModel)]="selectedReport">
          <option value="" disabled>-- Choose Report --</option>
          <option *ngFor="let rep of reportList" [value]="rep.value">
            {{ rep.key }}
          </option>
        </select>
      </div>

      <!-- Download Button -->
      <div class="col-lg-4 col-md-5 col-sm-12 mb-2">
        <button class="btn dash-btn success w-100" [disabled]="!selectedReport" (click)="downloadReport()">
          <i class="fas fa-download"></i>
          Download
        </button>
      </div>

    </div>

  </div>

</div>